import { ButtonWithScaleAnimation } from "by/gamefactory/cityversetycoon/scenes/common/components/ButtonWithScaleAnimation";
import { MyWalletResourcePackage } from "../../resources/MyWalletResourcePackage";
import { Text, TextStyle } from "pixi.js";
import { GameFont } from "by/gamefactory/cityversetycoon/scenes/common/GameFont";

export class MyWalletDisconnectButton extends ButtonWithScaleAnimation {
    private static readonly DISCONECT_TEXT = 'DISCONNECT';
    private readonly disconectText: Text;

    public constructor(myWalletResources: MyWalletResourcePackage) {
        super(myWalletResources.assets_views_my_wallet_ui_disconnect_icon_png);
        this.disconectText = new Text(MyWalletDisconnectButton.DISCONECT_TEXT, new DisconnectTextStyle());
        this.addChild(this.disconectText);
        this.disconectText.position.set(this.defaultView.width + 12, 3);
    }
}

class DisconnectTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 36,
            fill: '2A99FF',
            trim: true
        });
    }
}